import React from 'react';
import PropTypes from 'prop-types';

export default class TaxFlowChartSectionThreeResult extends React.Component {
  constructor() {
    super();
    this.renderMobileView = this.renderMobileView.bind(this);
    this.renderDesktopView = this.renderDesktopView.bind(this);
    this.renderValidQBIDesktopView = this.renderValidQBIDesktopView.bind(this);
    this.renderInvalidQBIDesktopView = this.renderInvalidQBIDesktopView.bind(this);
  }
  renderMobileView() {
    const eligibleImage = this.props.validQBI ? 'eligible-2x.png' : 'not-eligible-2x.png';
    const eligibleText = this.props.validQBI ? 'Yes, you are ' : 'No, you are not ';
    return (
      <React.Fragment>
        <div className="col-xs-6 col-xs-offset-3">
          <img src={`${this.props.cdnURL}/images/TaxFlowChart/${eligibleImage}`} alt="Eligibility" />
        </div>
        <div className="col-xs-12">
          <p>{eligibleText} eligible to file as a sole proprietor! </p>
        </div>
      </React.Fragment>
    );
  }

  renderDesktopView() {
    if (this.props.validQBI) {
      return this.renderValidQBIDesktopView();
    }
    return this.renderInvalidQBIDesktopView();
  }

  renderValidQBIDesktopView() {
    if (this.props.top) {
      return (
        <React.Fragment>
          <div className="col-sm-4 col-sm-offset-1">
            <p>Yes, you are eligible to file as a sole proprietor! </p>
          </div>
          <div className="col-sm-2">
            <img src={this.props.iconSrc} alt="User Icon" />
          </div>
        </React.Fragment>
      );
    }
    return (
      <div className="col-sm-2 col-sm-offset-2">
        <img src={`${this.props.cdnURL}/images/TaxFlowChart/eligible-2x.png`} alt="Eligible" />
      </div>
    );
  }

  renderInvalidQBIDesktopView() {
    if (this.props.top) {
      return (
        <div className="col-sm-4 col-sm-offset-1">
          <p>No, you are not eligible to file as a sole proprietor </p>
        </div>
      );
    }
    return (
      <React.Fragment>
        <div className="col-sm-2 col-sm-offset-2">
          <img src={`${this.props.cdnURL}/images/TaxFlowChart/not-eligible-2x.png`} alt="Not Eligible" />
        </div>
        <div className="col-sm-2 col-sm-offset-1">
          <img src={this.props.iconSrc} alt="User Icon" />
        </div>
      </React.Fragment>
    );
  }

  render() {
    if (this.props.section <= 2) {
      return null;
    }
    if (this.props.mobile) {
      return this.renderMobileView();
    }
    return this.renderDesktopView();
  }
}

TaxFlowChartSectionThreeResult.defaultProps = {
  iconSrc: '',
  mobile: false,
  top: false,
};

TaxFlowChartSectionThreeResult.propTypes = {
  validQBI: PropTypes.bool.isRequired,
  iconSrc: PropTypes.string,
  top: PropTypes.bool,
  mobile: PropTypes.bool,
  section: PropTypes.number.isRequired,
  cdnURL: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/TaxFlowChart/components/TaxFlowChartSectionThreeResult.jsx